export const URL_PARAM_ROOT_CUSTOMER_ID = 'rootCustomerId'
export const URL_PARAM_EMAIL = 'email'
